import React from 'react';
import {DataItem} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import {IDeveloperField} from 'dromo-uploader-react';
import {useTranslations} from 'src/providers/translation';
import HookFormSelectInput from 'src/hook-form-wrapper/select-input';

interface DisplayProps {
  value: string;
  items: {value: any; label: string}[];
}

interface Props {
  name?: string;
  type?: string;
  items: {value: any; label: string}[];
}

const durationArray = [
  {
    value: 'average_time',
    label: 'Average Time',
  },
  {
    value: 'total_time',
    label: 'Total Time',
  },
];

export const Import = (
  key: string = 'unit',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'Duration',
  key,
  type: 'select',
  selectOptions: durationArray.map(item => ({
    ...item,
    value: item.value.toString(),
  })),
  validators: [
    {
      validate: 'required',
    },
  ],
});

export const Value = (value: string, items: any) => {
  return items.find(item => item.value.toString() === value)?.label;
};

export const Display = ({value, items}: DisplayProps) => {
  const translations = useTranslations();

  return (
    <DataItem>
      <Text style={[Typography.H6]}>{translations('unit')}</Text>
      <Text style={[Typography.P3]}>{Value(value, items)}</Text>
    </DataItem>
  );
};

export const Input = ({name, type, items}: Props) => {
  const translations = useTranslations();

  return (
    <HookFormSelectInput
      name={(name ? name + '.' : '') + type}
      label={translations('unit')}
      placeholder={translations('unit')}
      helper={''}
      required={false}
      items={items}
    />
  );
};

export const validation = () => Yup.string().required('Duration is required');

export default Input;
